// @ts-nocheck
export const subtotalLimitRule = () => ({
  name: 'subtotal-limit',
  validate(cartState = null, mutation = null) {
    return {
      allowed: true,
      modifiedMutation: mutation,
    };
  },
});
